// Celect - Custom select component
// TODO take out into lib

import angular from 'angular';
import CelectComponent from './celect.component';
import CelectOptionComponent from './celect-option.component';

const CelectModule = angular.module('celect', [])

.component('celect', CelectComponent)
.component('celectOption', CelectOptionComponent);

export default CelectModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/celect/index.js